export default "__VITE_ASSET__Bw6jv2ty__"